import React, { Component } from 'react';
import styled from 'styled-components';
import css from 'css';
import { H3 } from 'partials/typography';

import Grid from '../grid/Grid';
import GridElement from '../grid/GridElement';
import TimeBlockGrid from './TimeblockGrid';

export class CalendarGrid extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { unit, index, courses, options, selectedPeriod } = this.props;

        return (
            <Wrapper>
                { unit.block ? 
                    <TimeUnitGridElement
                        colStart={1}
                        colEnd={6}
                        rowStart="auto"
                        align="start"
                    >
                        <H3>{unit.block}</H3>
                    </TimeUnitGridElement>
                : null}
                    
                <Grid>
                    <GridElement
                        colStart={1}
                        colEnd={6}
                        rowStart={index + 1}
                    >
                        <Grid>
                            { unit.timeSlots.map((slot, i) => {
                                return (
                                    <TimeSlotGridElement
                                        colStart={1}
                                        colEnd={6}
                                        rowStart="auto"
                                        key={i}
                                    >
                                        <p>{slot.from}</p>
                                        <p>{slot.to}</p>
                                    </TimeSlotGridElement>
                                )}
                            )}
                        </Grid>
                    </GridElement>
                    <GridElement
                        colStart={1}
                        colEnd={6}
                        rowStart={index + 1}
                    >
                        <TimeBlockGrid 
                            courses={courses}
                            options={options}
                            index={index} 
                            selectedPeriod={selectedPeriod}
                            handleCollision={this.props.handleCollision}
                        />
                    </GridElement>
                </Grid>
                    
            </Wrapper>
        )
    }
}

export default CalendarGrid;

const Wrapper = styled.div`
    h3, p {
        color: #fff;
        transform: translateX(-60px);
    }
`

const TimeUnitGridElement = styled(GridElement)`
    border-top: 1px solid ${css.colors.blue};
    padding: 30px 0;

    @media(max-width: 1300px){
        h3{
            margin-left: 35px; 
        }
    }
`

const TimeSlotGridElement = styled(GridElement)`
    border-top: 1px solid ${css.colors.blue};
    padding: 5px 0;
`



// WEBPACK FOOTER //
// ./src/partials/modules/TimePlanNew/timetable/CalendarGrid.js